<template>
    <checkout-step step-num="4" :step="step" stepName="Payment" @continue="validate" @edit="$emit('edit')">
        <div slot="active">
            <b-field>
                <b-checkbox name="pay_by_phone" v-model="data.pay_by_phone">Pay by phone</b-checkbox>
            </b-field>
            <form v-if="!data.pay_by_phone">
                <b-field label="Card Number" :message="errors.first('card_number')">
                    <b-input type="text" name="card_number" placeholder="4111111111111111" :icon="ccIcon" icon-pack="fa" v-model.trim="data.card_number" v-validate="{required: true, creditCard: true}" v-cleave="masks.creditCard"></b-input>
                </b-field>
                <b-field grouped>
                    <b-field label="Expiry Year" :message="errors.first('expiry_year')" expanded>
                        <b-input type="number" name="expiry_year" placeholder="2020" v-model.number="data.expiry_year" v-validate="{required: true, expYear: true}"></b-input>
                    </b-field>
                    <b-field label="Expiry Month" :message="errors.first('expiry_month')" expanded>
                        <b-input type="number" name="expiry_month" placeholder="8" v-model.number="data.expiry_month" v-validate="{required: true, expMonth: true}"></b-input>
                    </b-field>
                    <b-field label="CVC" :message="errors.first('cvc')" expanded>
                      <b-input type="number" name="cvc" placeholder="123" v-model.trim="data.cvc" v-validate="{required: true, length: 3}"></b-input>
                    </b-field>
                </b-field>
            </form>
            <b-message v-else>
                We will call you in the next 24 hours to collect payment information
            </b-message>
        </div>
        <div slot="finished">
            <p v-if="data.pay_by_phone">Payment by phone</p>
            <p v-else-if="data.card_number.trim().length > 5">{{ '*'.repeat(data.card_number.length - 4) + data.card_number.substring(data.card_number.length - 4, data.card_number.length) }}</p>
        </div>
    </checkout-step>
</template>

<script>
import CheckoutStep from '../CheckoutStep';
import BInput from 'buefy/src/components/input/Input';
import BCheckbox from 'buefy/src/components/checkbox/Checkbox';
import BMessage from 'buefy/src/components/message/Message';
import BField from 'buefy/src/components/field/Field';
import { card } from 'creditcards';
import Cleave from 'cleave.js'

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input')
    input._vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input._vCleave.destroy()
  }
}
    
export default {
  components: {
    BField,
    BMessage,
    BCheckbox,
    BInput,
    CheckoutStep,
  },

  directives: { cleave },
  data() {
    return {
      value: '',
      rawValue: '',
      masks: {
        creditCard: { creditCard: true },
        numeral: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          prefix: '$ '
        }, 
        
        /*
        custom: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 2],
          numericOnly: true
        } 
        */

      }
    }
  },
              
  name: 'checkout-payment',

  props: ['data', 'step'],

  computed: {
    ccType() {
      return card.type(this.data.card_number, true);
    },

    ccIcon() {
      switch (this.ccType) {
        case 'Visa':
          return 'cc-visa';
        case 'American Express':
          return 'cc-amex';
        case 'MasterCard':
          return 'cc-mastercard';
        default:
          return 'credit-card-alt';
      }
    },
  },

  methods: {
    validate() {
      this.$validator.validateAll().then((valid) => {
        if (valid) this.$emit('valid');
      });
    },
    
  },
  
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout-steps/CheckoutStep4.vue